import { cn } from "@/lib/utils"
import { getOS } from "@/shared/lib/native-browser"
import { AppleIcon, GoogleIcon } from "./brand-icons"

interface SignInButtonsProps {
  onApple: () => void
  onGoogle: () => void
  className?: string
}

/**
 * Apple + Google sign-in buttons shared by the post-purchase `/create-account`
 * and the emailed `/activate` screens. Apple ID is virtually unused on Android,
 * so that button is hidden there (Google only).
 */
export function SignInButtons({ onApple, onGoogle, className }: SignInButtonsProps) {
  const isAndroid = getOS() === "android"

  return (
    <div data-slot="sign-in-buttons" className={cn("flex w-full flex-col gap-1", className)}>
      {!isAndroid && (
        <>
          <button
            type="button"
            onClick={onApple}
            className="flex h-14 w-full items-center justify-center gap-2 rounded-3xl bg-purple-light/10 text-base font-semibold text-white transition-colors hover:bg-purple-light/15"
          >
            <AppleIcon className="size-[22px] fill-white" />
            Sign in with Apple
          </button>

          <div className="flex items-center gap-4 px-4 py-2">
            <span className="h-px flex-1 bg-purple-light/20" />
            <span className="text-base text-purple-light/40">or</span>
            <span className="h-px flex-1 bg-purple-light/20" />
          </div>
        </>
      )}

      <button
        type="button"
        onClick={onGoogle}
        className="flex h-14 w-full items-center justify-center gap-2 rounded-3xl bg-purple-light/10 text-base font-semibold text-white transition-colors hover:bg-purple-light/15"
      >
        <GoogleIcon className="size-[22px]" />
        Sign in with Google
      </button>
    </div>
  )
}
